import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ProgressSpinnerModule } from 'primeng/progressspinner'

@Component({
  selector: 'app-loading-indicator',
  template: `
   <div
      style="text-align: center; margin-top: 4rem; display: flex; flex-direction: column">
    <p-progressSpinner
      [style]="{ width: '3.5rem', height: '3.5rem' }"
      styleClass="w-4rem h-4rem geek-spinner"></p-progressSpinner>
    <span>Search results are loading</span>
    </div>

  `,
  styles: [
    `
      :host ::ng-deep .geek-spinner .p-progress-spinner-circle {
        animation: geek 3s ease-in-out infinite;
      }

      @keyframes geek {
        0% {
          stroke: #8a00e5;
          stroke-opacity: 0;
        }
        25% {
          stroke: #8a00e5;
          stroke-opacity: 0.5;
        }
        50% {
          stroke: #8a00e5;
          stroke-opacity: 1;
        }
        75% {
          stroke: #8a00e5;
          stroke-opacity: 0.5;
        }
        100% {
          stroke: #8a00e5;
          stroke-opacity: 0;
        }
      }
    `,
  ],
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
})
export class LoadingIndicatorComponent {}
